import { Alert } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { captionText } from '../styles/colors'
import useFetch from '../hooks/useFetch'
import { putAddUserToRestaurant } from '../config/apiRoutes'
import { selfSignupRoute, usePathReconstructor } from '../config/pageRoutes'
import { StandardLink } from '../styles/links'
import AddIcon from '@mui/icons-material/Add';
import { validateEmail } from '../models/validate'
import UserContext from '../contexts/UserContext'
import StandardTextInput from '../inputs/StandardTextInput'
import EmailIcon from '@mui/icons-material/Email';
import PrimaryButton from '../buttons/PrimaryButton'

type Props = {
    onUserAdded: () => void;
    onCancel: () => void;
}

const AddUserForm = (props: Props) => {
    const { copyParamsFromPath } = usePathReconstructor();
    const { selectedRestaurant } = useContext(UserContext);
    const { t } = useTranslation();
    const [email, setEmail] = useState<string>('');
    const [isEmailValid, setIsEmailValid] = useState<boolean>(false);
    const [showError, setShowError] = useState<boolean>(false);
    const { call, errorMessage } = useFetch();

    useEffect(() => {
        setIsEmailValid(validateEmail(email));
    }, [email]);

    function handleEmailChange(e: React.ChangeEvent<HTMLInputElement>) {
        setEmail(e.target.value);
    }

    async function handleSubmit() {
        if (selectedRestaurant == null) return;
        const response = await call<any, undefined>("PUT", putAddUserToRestaurant.replace(":restaurantShortName", selectedRestaurant.restaurantShortName), { email });
        if (response.ok) {
            setShowError(false);
            props.onUserAdded();
        } else {
            setShowError(true);
        }
    }

    return (
        <div className="p-3">
            <div className="text-center font-bold text-[20px] pb-2">
                {t("common.add_user_title")}
            </div>
            <div className="pb-2">
                <div className="text-primary-dark text-[15px]" color={captionText} >
                    {t("common.user_add_to_restaurant_tip")}
                </div>
                <StandardLink
                    to={copyParamsFromPath(selfSignupRoute.path)}
                    target={"_blank"}
                >
                    {t("common.sign_up_here")}
                </StandardLink>
            </div>
            <StandardTextInput
                type="email"
                label={t("auth.email")}
                value={email}
                onChange={handleEmailChange}
                error={!isEmailValid && email.length > 0}
                helperText={!isEmailValid && email.length > 0 ? t("auth.invalid_email") : undefined}
                endIcon={<EmailIcon />}
            />
            <div className="mt-3 flex justify-end gap-3">
                <PrimaryButton
                    disabled={!isEmailValid}
                    onClick={handleSubmit}
                    variant="strike"
                >
                    {t("common.add_user")}
                    <AddIcon className='end-icon' />
                </PrimaryButton>
                <PrimaryButton
                    variant="outlined"
                    onClick={props.onCancel}
        
                >
                    {t("common.cancel")}
                </PrimaryButton>
            </div>
            <div className="mt-2">
                {showError && (
                    <Alert severity='error' variant="filled" >
                        {t("common.error")}: {t(`common.${errorMessage}`)}
                    </Alert>
                )}
            </div>
        </div>
    )
}

export default AddUserForm